export default "__VITE_ASSET__CQ0Ri6q5__"